export default "__VITE_PUBLIC_ASSET__2c34c658__"